import React from 'react'
import classNames from 'classnames'

export interface ChildrenProps {
  children: React.ReactNode
}

export const NavContainer: React.FC<ChildrenProps> = ({ children }) => {
  return (
    <div className="mb-6 mt-6 mx-4 min-tablet:mx-0">
      <nav
        className={classNames(
          'grid grid-cols-2 tablet:grid-cols-4 gap-4 min-w-0',
          'desktop:min-w-80 w-full'
        )}
      >
        {children}
      </nav>
    </div>
  )
}
